/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ElementGroupElementPresentationFromJSON, ElementGroupElementPresentationToJSON, StreemApiPointFromJSON, StreemApiPointToJSON, StreemApiTransformFromJSON, StreemApiTransformToJSON, } from './';
export function ElementGroupFromJSON(json) {
    return ElementGroupFromJSONTyped(json, false);
}
export function ElementGroupFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'anchorId': !exists(json, 'anchor_id') ? undefined : json['anchor_id'],
        'elements': !exists(json, 'elements') ? undefined : (json['elements'].map(ElementGroupElementPresentationFromJSON)),
        'offset': !exists(json, 'offset') ? undefined : StreemApiTransformFromJSON(json['offset']),
        'focalPoint': !exists(json, 'focal_point') ? undefined : StreemApiPointFromJSON(json['focal_point']),
    };
}
export function ElementGroupToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'anchor_id': value.anchorId,
        'elements': value.elements === undefined ? undefined : (value.elements.map(ElementGroupElementPresentationToJSON)),
        'offset': StreemApiTransformToJSON(value.offset),
        'focal_point': StreemApiPointToJSON(value.focalPoint),
    };
}
//# sourceMappingURL=ElementGroup.js.map